import React from 'react';

const SuperAdminRecalledSheet = () => {
    return (
        <div style={{ fontFamily: 'Arial, sans-serif' }}>
            <h2 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px", fontFamily: "Arial, sans-serif" }}>
                How to Recall a Timesheet as a Super Admin?
            </h2>
            <p>
                This section explains the steps to recall a timesheet if you are logged in as a Super Admin. A recall request allows you to modify an already submitted and approved timesheet.
            </p>
            
            <h4>Steps to Recall a Timesheet</h4>
            <ol>
                <li>Click on the "Recall Sheets" option in the Super Admin Module.</li>
                <li>Select the timesheet that needs to be recalled and click on it.</li>
                <li>Click on "Approved" to approve the recall request.</li>
            </ol>

            
            <img
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1740684746/WhatsApp_Image_2025-02-26_at_9.37.24_PM_1_nz8egx.jpg "
                alt="Recall Sheets Option"
                style={{ width: '60%' }}
            />

            <p>
                <strong>Note:</strong> Once a recall request is approved, the sheet status changes to "In Progress," meaning it is now a pending timesheet. An email notification will be sent to the respective employee about the recall request.
            </p>

            <h4>Tip:</h4>
            <p>Click on "Notifications," select the timesheet status, and approve or reject it directly from there.</p>

            
            <img
                src=" https://res.cloudinary.com/danfpnuui/image/upload/v1740684825/WhatsApp_Image_2025-02-26_at_9.37.25_PM_2_pxkdtq.jpg"
                alt="Notifications Panel"
                style={{ width: '60%' }}
            />

            <p>
                <strong>Note:</strong> If you do not receive an email notification or face any issues, please reach out to the Gatnix Help Center.
            </p>

            <h4>Steps to Reject a Recall Request</h4>
            <ol>
                <li>Click on the "Recall Sheets" option in the Super Admin Module.</li>
                <li>Select the timesheet that needs to be rejected and click on it.</li>
                <li>Click on "Rejected" to reject the recall request.</li>
            </ol>

            <p>
                <strong>Note:</strong> If a recall request is rejected, the timesheet status will change to "Approved." A rejected recall request means the timesheet cannot be modified or edited further.
            </p>

            <h4>Tip:</h4>
            <p>Once a recall request is rejected, the corresponding timesheet becomes non-editable, ensuring that any modifications cannot be made post-rejection.</p>

            <p>
                The above section provides a detailed summary of all recalled timesheets, including the approval status and any comments provided by the approvers.
            </p>
        </div>
    );
};

export default SuperAdminRecalledSheet;
